export enum SnackbarType {
  Success = 0,
  Error = 1,
  Warning = 2,
  Info = 3,
}

export interface SnackbarAction {
  label: string;
  onClick: () => void;
}

export interface SnackbarData {
  id: string;
  icon: any;
  message: string;
  type: SnackbarType;
  duration?: number;
  action?: SnackbarAction;
  persistent?: boolean;
  createdAt: number;
}

export interface SnackbarConfig {
  maxSnackbars?: number;
  position?: "top-left" | "top-center" | "top-right" | "bottom-left" | "bottom-center" | "bottom-right";
  stackDirection?: "up" | "down";
  defaultDuration?: number;
}

export const DEFAULT_CONFIG: SnackbarConfig = {
  maxSnackbars: 5,
  position: "bottom-right",
  stackDirection: "up",
  defaultDuration: 3000,
};

export const SNACKBAR_COLORS = {
  [SnackbarType.Success]: "#D1EF70", // Default (overridden in component for theme-aware colors)
  [SnackbarType.Error]: "#EF4444",
  [SnackbarType.Warning]: "#E88053",
  [SnackbarType.Info]: "#E4E4E4",
} as const;

export const SNACKBAR_ROLES = {
  [SnackbarType.Success]: "status",
  [SnackbarType.Error]: "alert",
  [SnackbarType.Warning]: "alert",
  [SnackbarType.Info]: "status",
} as const;
